import { PageType } from './types';

/**
 * The backend serves page templates on `/pages/{pageType}/template`, where the segment is the
 * PageType enum name. Those routes enforce the template permissions (`COMPANY_PAGE_TEMPLATE` for
 * COMPANY_V2, MANUAL and NITRO_EXTERNAL, `MEETING_PAGE_TEMPLATE` for MEETING) and the matching
 * account feature flag.
 */
export const LEGACY_PAGE_TEMPLATE_BASE_PATH = 'pages/template';

/**
 * Callers that don't know the page type fall back to the legacy unscoped route, which the backend
 * still serves unchanged.
 */
export const getPageTemplateBasePath = (pageType?: PageType): string =>
  pageType ? `pages/${pageType}/template` : LEGACY_PAGE_TEMPLATE_BASE_PATH;

/* c8 ignore next 2 - simple path concatenation, tested indirectly via API integration tests */
export const getPageTemplateBuilderBasePath = (pageType?: PageType): string =>
  `${getPageTemplateBasePath(pageType)}/builder`;
